import { Container, Grid, Typography, Card, CardContent, CardHeader, styled, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import { useEffect, useState } from 'react'
import useWebService from '../../../services/web/useWebService'
import { ButtonClose } from '../../web/project/page/pageAction'
import { HistoryFileInfo } from '../../../services/web/types/responseWebServiceTypes'
import { formatDateToString } from '../../../utilities/date'
import { useHistory, useParams } from 'react-router-dom'
import useEditUsergroup from '../../../services/um/useEditUsergroup'

const CustomHeader = styled(CardHeader)({
    borderBottom: '1px solid #DCDCDC',
})

const CustomUnderlineGrid = styled(Grid)({
    borderBottom: '1px solid #DCDCDC',
})

function UserHistoryUpload() {
    const [historyInfo, setHistoryInfo] = useState<HistoryFileInfo[]>([])
    const translate = useTranslate()
    const classes = useStyles()
    const iconPath = '/img/icons/pdf.png'
    const { getUserHistoryUpload } = useWebService()
    const history = useHistory()
    const params = useParams<{ userID: string }>()
    const { officerInfo } = useEditUsergroup(params.userID)
    const handleClose = () => {
        history.push('/officer')
        setHistoryInfo([])
    }

    useEffect(() => {
        const getHistoryUpload = () => {
            const listFile = officerInfo?.documentInfo[0].uploadFileObj.fileList.filter(
                (item) => item.replaceFileID !== null,
            )
            listFile?.forEach(async (item) => {
                const { result } = await getUserHistoryUpload(item.replaceFileID, Number(params.userID))
                setHistoryInfo((prev) => [...prev, ...result])
            })
        }
        getHistoryUpload()
    }, [officerInfo?.documentInfo])
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <CustomHeader
                            title={
                                <Typography variant="h5">
                                    {translate.get('UM.USERGROUP.OFFICER.UPLOAD-HISTORY')}
                                </Typography>
                            }
                        />
                        <CardContent>
                            {historyInfo
                                .sort((a, b) => new Date(b.updatedDate).valueOf() - new Date(a.updatedDate).valueOf())
                                .map((data, index) => (
                                    <Grid container key={data.fileID} spacing={2}>
                                        {!!index && (
                                            <CustomUnderlineGrid item xs={12}>
                                                &nbsp;
                                            </CustomUnderlineGrid>
                                        )}
                                        <Grid item xs={12} md={12} lg={12}>
                                            <Typography variant="body2">
                                                {translate.get('LABEL.FILE_NAME')} :
                                                <img
                                                    src={process.env.PUBLIC_URL + iconPath}
                                                    alt="pdf"
                                                    className={classes.imgPDF}
                                                />
                                                <a href={data.path ?? ''}>{`   ${data.fileName}`}</a>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={6}>
                                            <Typography variant="body2">
                                                {translate.get('LABEL.FILE_UPLOAD_BY')} :{`  ${data.updatedBy}`}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                {translate.get('LABEL.FILE_UPLOAD_DATE')} :
                                                {`   ${formatDateToString([data.updatedDate])}`}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="flex-end">
                        <ButtonClose onClickClose={handleClose}></ButtonClose>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles(() => ({
    imgPDF: {
        width: 20,
        height: 20,
        margin: '0px 0px -5px 10px',
    },
}))

export default UserHistoryUpload
